import { KindergartenRoleEnum } from "@king-ict/eupisi-ui/models";

export default interface User {
  userId: number;
  oib: string;
  firstName: string;
  lastName: string;
  roleId: KindergartenRoleEnum;
  roleName: string;
  institutionId?: number;
  currentPedagogicalYearInstitutionId?: number;
  niasMessageId: string;
  niasNavigationToken: string;
  niasSessionId: string;
}

export const userInitial: User = {
  userId: 0,
  oib: "",
  firstName: "",
  lastName: "",
  roleId: KindergartenRoleEnum.Unknown,
  roleName: "",
  niasMessageId: "",
  niasNavigationToken: "",
  niasSessionId: "",
};
